import { useEffect } from 'react';
import { useAuthStore } from '@/store/auth.store';

/**
 * Listens for the `session-expired` DOM event dispatched by the Axios
 * interceptor on 401 responses and clears local auth state.
 * ProtectedRoute handles the subsequent redirect to /login.
 */
export function SessionExpiryWarning() {
  const clearAuth = useAuthStore((s) => s.clearAuth);

  useEffect(() => {
    const onSessionExpired = () => clearAuth();
    window.addEventListener('session-expired', onSessionExpired);
    return () => window.removeEventListener('session-expired', onSessionExpired);
  }, [clearAuth]);

  return null;
}
